import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';


function UnsubUserForm({ onChange }) {
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        onChange({
          email
        });
      }, [email]);
  
    return (
      <Form>
        <Form.Group controlId="formEmail">
            {/* <Form.Label>Email address</Form.Label> */}
            <Form.Control name="email" type="email" placeholder="Enter email" onChange={e => setEmail(e.target.value)} value={email} />
        </Form.Group>
        {error && (
            <div className="errors">
                <p className="text-danger">{error}</p>
            </div>
        )}
      </Form>
    );
  }

  export default UnsubUserForm;
